/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { ACROFORM_CLIENT_NAME, OVERLAY_VISIBILITY } from "../constants/constants";

export const getDocumentOverlaysApis = stores => {
  function registerOverlay(clientName, component, api = {}, options = {}) {
    function bringToFront() {
      stores.overlayDropinStore.sendOverlayToFront(clientName);
      return Promise.resolve(true);
    }

    function sendToBack() {
      stores.overlayDropinStore.sendOverlayToBack(clientName);
      return Promise.resolve(true);
    }

    function removeOverlay() {
      stores.overlayDropinStore.removePageOverlay(clientName);
      return Promise.resolve(true);
    }

    const overlayApis = {
      bringToFront,
      sendToBack,
      removeOverlay
    };

    if (component) {
      stores.overlayDropinStore.addPageOverlay({ component, clientName, api, options });
      return overlayApis;
    }
    return {};
  }

  function showOverlay(clientName) {
    stores.overlayDropinStore.setOverlayVisibility(clientName, OVERLAY_VISIBILITY.VISIBLE);
  }

  function hideOverlay(clientName) {
    stores.overlayDropinStore.setOverlayVisibility(clientName, OVERLAY_VISIBILITY.HIDDEN);
  }

  return {
    registerOverlay,
    showOverlay,
    hideOverlay
  };
};
